import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import langAdminDocumentDownloadLogs from '../langs/langAdminDocumentDownloadLogs';
import LAdmin from '../layouts/LAdmin';
import VAdminDocumentDownloadLogs from '../views/VAdminDocumentDownloadLogs';

const PAdminDocumentDownloadLogs = () => {
	const { t } = useTranslation();
	return (
		<LAdmin>
			<Helmet>
				<title>IRP Admin tools - {t(langAdminDocumentDownloadLogs.title.tag)}</title>
			</Helmet>
			<VAdminDocumentDownloadLogs />
		</LAdmin>
	);
};

export default PAdminDocumentDownloadLogs;
